import request from '@/assets/js/jbbDataRequest'
import jbbRequest from '@/assets/js/request'

/**
 * 查询字典列表
 * @param {String} code 编码
 * @returns {Promise} => 字典列表
 */
export function getDictList(code) {
  return request.get(`/jbb-data/sys/system/enum-dict/list?typeCode=${code}`)
}

/**
 * 查询客户推荐人
 * @param {Number} customerId 客户id
 * @returns {Promise} => 客户推荐人
 */
export function getCustomerReferer(customerId) {
  return request.get(`/jbb-data/ord/order/order/getCusCommend?customerId=${customerId}`)
}

/**
 * 查询客户的邦邦豆余额
 * @param {Number} customerId 客户id
 * @returns {Promise} => 客户的邦邦豆余额
 */
export function getCustomerBeanCount(customerId) {
  return request.get(`/jbb-data/ord/order/city-cost/getCostByCostomerId?customerId=${customerId}`)
}

/**
 * 查询会计列表
 * @param {String} type 会计类型 1：财税顾问 2：做账会计
 * @returns {Promise} => 会计列表
 */
export function getAccountingList(type) {
  return jbbRequest.get(`jbbcs/KeepAccount/getAccountPersonInfo?type=${type}`)
}

/**
 * 获取手机号码
 * @param {Object} params 查询参数
 * @returns {Promise} => 手机号码
 */
export function getMobile(params) {
  return jbbRequest.get('jbbcs/customer/getMobile', { params })
}

/**
 * 查询部门和员工数数据
 * @param {String} name 名称
 * @returns {Promise} => 部门和员工数数据
 */
export function getDeptAndUserTree(name) {
  return jbbRequest.get('/jbbcs/busWork/getDepartTree', { params: { name } })
}

/**
 * 查询标签列表
 * @param {Object} params 查询参数
 * @returns {Promise} => 标签列表
 */
export function getTagList(params) {
  return jbbRequest.get('/jbbcs/cusTag/tagListWithCategory', { params })
}

/**
 * 获取支付方式列表
 * @returns {Promise} => 支付方式列表
 */
export function getPayWayList() {
  return request.get('/jbb-data/comm/sys/sys/companyAccount')
}

/**
* 查询客户标签列表
 * @param {Object} params 查询参数
 * @returns {Promise} => 客户标签列表
 */
export function getCustomerTagList(params) {
  return jbbRequest.get('/jbbcs/cusTag/tagListByCategoryCode', { params })
}

/**
 * 查询OA表单是否可修改
 * @param {Object} params 查询参数
 * @returns {Promise} => OA表单可修改标志
 */
export function getOAFormEditFlag(params) {
  return request.get('/jbb-data/workflow/workflow_task_instance/isModify', { params })
}



// WEBPACK FOOTER //
// ./src/apis/jbbData/common.js